<template>
  <div class="reset">
    <div class="container">
      <div class="reset__wrapper">
        <reset-password-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import ResetPasswordForm from "@/components/forms/reset-password-form.vue";
</script>

<style lang="scss" scoped>
.reset {
  background-image: url(@images/authBg.png);
  background-repeat: no-repeat;
  background-size: cover;

  &__wrapper {
    padding-block: 100px 175px;
    display: grid;
    place-items: center;
  }
}
</style>